import { getSiteConfig } from "../config/siteConfigService";

/**
 * Configure site with settings from appsettings.json
 * @returns {Promise<void>}
 */
export const configureSite = async () => {
  const siteConfigSettings = await getSiteConfig();

  if (validateConfigSettings(siteConfigSettings)) {
    SiteConfig.MatomoContainerName = siteConfigSettings.matomoContainerName;
  } else {
    throw new Error("Invalid or empty configuration file appsettings.json");
  }
};

/**
 * Validate configuration settings
 * @param {{matomoContainerName: string}} siteConfigSettings
 * @returns {boolean}
 */
const validateConfigSettings = (siteConfigSettings) => {
  return Boolean(siteConfigSettings?.matomoContainerName);
};

/**
 * SiteConfig class to store configuration
 */
export class SiteConfig {
  static MatomoContainerName = "";
}
